/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { jsx, css } from '@emotion/react'
import { head, get } from 'lodash'
import { Link } from 'react-router-dom'
import AdminMainLayout from './AdminMainLayout'
import AdminUserForm from './AdminUserForm'
import BusyMask from '../../components/BusyMask'
import CurrencyValue from '../../components/CurrencyValue'
import Timestamp from '../../components/Timestamp'
import { adminCallForwardingCostStructureVariantList } from '../actions/admin_call_forwarding_cost_structure_variant'
import Card from '../../components/layout/Card'
import CommonTable from '../../components/CommonTable'
import { Button, Container } from 'react-bootstrap'
import AdminTableHeader from './AdminTableHeader'
import AdminTableFilter from './AdminTableFilter'

class AdminCallForwardingCostStructureVariants extends Component {

    componentDidMount() {
        const { dispatch } = this.props
        dispatch(adminCallForwardingCostStructureVariantList.fetchListIfNeeded())
    }

    componentDidUpdate(prev_props) {
        const { dispatch } = this.props
        dispatch(adminCallForwardingCostStructureVariantList.fetchListIfNeeded())
    }

    onEditCallForwardingCostStructureVariant = (evt, item) => {
        const { history } = this.props
        history.push({
            pathname: '/admin/call_forwarding_cost_structure_variant/'+item.id
        })
    }

    onAddCallForwardingCostStructureVariant = () => {
        const { history } = this.props
        history.push('/admin/call_forwarding_cost_structure_variant')
    }
    
    filterCallForwardingCostStructureVariants = (filter_values) => {
        const { dispatch } = this.props
        dispatch(adminCallForwardingCostStructureVariantList.updateListFilter(filter_values))
    }


    getCellValue = (header_key, item, index) => {
        switch( header_key ) {
            case 'action':
                return (
                    <Button onClick={(evt) => this.onEditCallForwardingCostStructureVariant(evt, item)}>
                      Edit
                    </Button>
                )
                
            default:
                return undefined
        }
    }

    render() {
        const { is_loading, headers, call_forwarding_cost_structure_variants } = this.props
        return (
            <AdminMainLayout breadcrumbs={[{name: 'admin_home'},
                                           {name: 'call_forwarding_cost_structure_variants', label: 'Call Forwarding Cost Variants', url: '/admin/call_forwarding_cost_structure_variants'}]}>
              <Container fluid>
                <AdminTableHeader title="Call Forwarding Cost Structure Variants">
                  <AdminTableFilter
                      updateOnChange={ this.filterCallForwardingCostStructureVariants }
                      form="ADMIN_CALL_FORWARDING_COST_STRUCTURE_VARIANTS_FILTER_FORM"
                  />
                  <Button variant="outline-primary" onClick={ this.onAddCallForwardingCostStructureVariant }>
                    Add call forwarding cost variant
                  </Button>
                </AdminTableHeader>
                <CommonTable
                    is_loading={ is_loading }
                    empty_message={`There are no call forwarding cost variants.`}
                    headers={ headers }
                    items={ call_forwarding_cost_structure_variants }
                    item_list={adminCallForwardingCostStructureVariantList}
                    getCellValue={ this.getCellValue }
                />
              </Container>
            </AdminMainLayout>
        )
    }
}

function mapStateToProps(state, props) {
    const call_forwarding_cost_structure_variants = adminCallForwardingCostStructureVariantList.getVisibleObjects()
    return {
        call_forwarding_cost_structure_variants,
        is_loading: adminCallForwardingCostStructureVariantList.isLoading(),
        headers: {
            name: {name: 'Name'},
            inherits_from_name: {name: 'Based on'},
            action: { name: '', column_size: 1 }
        }
    }
}

export default connect(mapStateToProps)(AdminCallForwardingCostStructureVariants)
